// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__22nfd","title":"AfterBackImages_title__1KSkr","images":"AfterBackImages_images__1e3GU"};